export const ScreensKey: any = {
    Participants: 'participant_list'
}

export enum DocumentPortal {
    EmployerPortal,
    MunicipalityPortal,
}